import React, { useMemo } from 'react';
import { parsePriceAndAgeFromNumericFilters } from '../../utils';
import { validAgeSelectionOptions } from '../../../../utils/constants';

interface Props {
  numericFilters: (string|string[])[],
  resetSelectedAge: () => void,
}

/**
 * We must add age separately, since it's technically a numericFilter
 * not a refinement
 */
const CustomCurrentAgeRefinement = ({
  numericFilters,
  resetSelectedAge,
}: Props) => {
  const selectedAgeLabel = useMemo(() => {
    const {
      diffInMonths,
    } = parsePriceAndAgeFromNumericFilters(numericFilters);
    const foundSelectedAgeValue = validAgeSelectionOptions.find(
      (option) => option.value === diffInMonths.toString(),
    );
    if (foundSelectedAgeValue) {
      return foundSelectedAgeValue.label;
    }
    return '';
  }, [numericFilters]);

  if (selectedAgeLabel) {
    return (
      <li className="ais-CurrentRefinements-item">
        <span className="ais-CurrentRefinements-label">
          Age:
        </span>
        <span className="ais-CurrentRefinements-category">
          <span className="ais-CurrentRefinements-categoryLabel">
            {selectedAgeLabel}
          </span>
          <button
            className="ais-CurrentRefinements-delete"
            onClick={resetSelectedAge}
          >
            ✕
          </button>
        </span>
      </li>
    );
  }
  return null;
};

export default CustomCurrentAgeRefinement;
